export default function () {
	const query = window.location.search.substring(1);
	const variableStrings = query.split('&');
	const variablesObj = {};

	for (let i = 0; i < variableStrings.length; i++) {

		const variableString = variableStrings[i].trim();

		if (variableString.length) {
			const variableSplit = variableString.split('=');

			const variableName = variableSplit[0].trim();
			let variableValue = variableSplit.length > 1 ? variableSplit[1].trim() : true;

			if (variableValue === 'true') {
				variableValue = true;
			}

			variablesObj[variableName] = variableValue;
		}
	}

	return variablesObj;
}
